import { AdaptedVariant, PaymentVariantType } from '../../model/types/PaymentSchema'
import { conditionAdapter } from '../paymentAdapter'

export const paymentAdapter = (paymentList: PaymentVariantType[]): AdaptedVariant[] =>
	paymentList.map(
		({ PSA_NAME, INSTALLMENT_CODES, ID, SPECIAL_CONDITIONS, LOGOTIP, DESCRIPTION, SYSTEM, isInstallment = false }) => {
			const adapted: AdaptedVariant = {
				name: PSA_NAME,
				logotip: LOGOTIP,
				description: DESCRIPTION,
				id: ID,
				system: SYSTEM,
				isInstallment
			}

			if (INSTALLMENT_CODES && Array.isArray(INSTALLMENT_CODES)) {
				adapted.installmentCodes = INSTALLMENT_CODES
				adapted.allowedInstallments = INSTALLMENT_CODES.map((value: string) => +value.split(`-`)[2])
			}

			if (SPECIAL_CONDITIONS && Array.isArray(SPECIAL_CONDITIONS) && SPECIAL_CONDITIONS.length > 0) {
				adapted.specialConditions = conditionAdapter(SPECIAL_CONDITIONS)
			}

			return adapted
		}
	)
